<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="话题名称：" prop="topic_name">
                <span>{{model.topic_name}}</span>
            </el-form-item>
            <el-form-item label="话题描述：" prop="topic_desc">
                <span>{{model.topic_desc}}</span>
            </el-form-item>
            <el-form-item label="话题图片：" prop="topic_img">
                <span>{{model.topic_img}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="浏览量：" prop="view_count">
                <span>{{model.view_count}}</span>
            </el-form-item>
            <el-form-item label="参与量：" prop="join_count">
                <span>{{model.join_count}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'momentTopicInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                topic_name: '',
                topic_desc: '',
                topic_img: '',
                order_index: '',
                state: '',
                view_count: '',
                join_count: '',
            },
            getObj:{
                url:'/api/admin/momenttopic/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>